export const normalizeMenuKey = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

export const normalizePermissionKey = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase();

export const menuKeyToPermissionSlug = (menuKey = '') =>
  String(menuKey || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const buildPagePermissionKey = (menuKey = '', action = 'view') => {
  const slug = menuKeyToPermissionSlug(menuKey);
  const normalizedAction = String(action || 'view')
    .trim()
    .toLowerCase();
  if (!slug) return '';
  return `page.${slug}.${normalizedAction}`;
};

export const findMenuItemForPath = (pathname = '', menuItems = []) => {
  const normalizedPath = String(pathname || '').trim();
  if (!normalizedPath || !Array.isArray(menuItems)) return null;

  let bestMatch = null;
  for (const item of menuItems) {
    const route = String(item?.route || '').trim();
    if (!route) continue;
    if (normalizedPath === route || normalizedPath.startsWith(`${route}/`)) {
      if (!bestMatch || route.length > String(bestMatch.route || '').length) {
        bestMatch = item;
      }
    }
  }
  return bestMatch;
};
